// import constants from './CityViewConstants';

const initialState = {
    apartments: [],
    aptsCount: '',
    city: {
        id: '',
        name: '',
        background: null,
    },
    query: {
        neighborhood: [],
        rooms: '',
        beds: '',
        bethrooms: '',
        price: {
            min: '',
            max: '',
        },
        amenities: [],
        date: {
            checkIn: null,
            checkOut: null,
        },
    },
    map: {
        fullscreen: false,
    },
};

export default (state = initialState, action) => {
    switch (action.type) {
    default:
        return state;
    }
};



// WEBPACK FOOTER //
// ./src/containers/CityView/CityViewReducer.js